// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ihLi","body":"App_body__2BrBb app-background-color"};